import { EFilterType } from 'shared/enums/EFilterType';

export enum EButtonTarget {
  findButton = 'findButton',
  moreButton = 'moreButton',
}

export type OffersCountTooltipTarget = EFilterType | EButtonTarget | null;
